import { gql } from "@apollo/client";

export const GET_ALL_ESTADOS = gql`
query GetAllEstados {
    allEstadosPrePaciente
    {
        nombre,
        id,
    }
}`;